import React from 'react';
import { useLoadingContext } from '../../login/context/LoadingContext.tsx';
import Loading from '../loading/Loading.tsx';
import './confirm-modal.scss';

interface ConfirmModalProps {
  action: () => void;
  cancel: () => void;
  bodyText?: React.ReactNode;
  confirmText?: string;
  body?: any;
}

const ConfirmModal = ({
  action,
  cancel,
  bodyText,
  confirmText,
  body,
}: ConfirmModalProps) => {
  const { isLoading } = useLoadingContext();

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {isLoading ? (
          <Loading fullScreen={false} />
        ) : (
          <>
            <p style={{ whiteSpace: 'pre-line' }}>{bodyText}</p>
            {body && body}
            <div className="modal-buttons">
              <button className="cancel-button" onClick={cancel}>
                Cancelar
              </button>
              <button className="confirm-button" onClick={action}>
                {confirmText}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ConfirmModal;
